import { render, staticRenderFns } from "./UviExportConfigurationView.vue?vue&type=template&id=1b77e795&"
import script from "./UviExportConfigurationView.vue?vue&type=script&lang=ts&"
export * from "./UviExportConfigurationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports